import HeadTittle from "../../../../../components/HeadTittle";
import routes from "../../../../../Routes/routes";
import React from "react";
import {useTranslation} from "react-i18next";
import EmployeeFlowDocumentDetail from "../../../Supplier/SubComponents/SupplierDetailsFlows/EmployeeFlowDocumentDetail";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const EmployeeFlowSupplierOrderDetail = () => {
    const { t } = useTranslation();


    return (
        <>
            <HeadTittle name={t('complete_documents') }
                        link={routes.suppliers.main}
            />
            <EmployeeFlowDocumentDetail
                disabled={false}
                deleteEmployeeShow={false}
                setDeleteEmployeeShow={false}
                unlinkShow={false}
                setUnlinkShow={false}
                showBtnDeleteDoc={true}
            />
        </>
    )
}

export default EmployeeFlowSupplierOrderDetail
